module.exports = __webpack_public_path__ + "img/ic_store_function_img1.1e289d3f.png";